import React, { useCallback, useMemo } from "react";
import { Icon, IconButton, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import useSurveys from "../state/hooks/useSurveys";
import { SHOW_SURVEY_RESULTS } from "../lib/results";

export default function SurveyShowResultsButton() {
  const { t } = useTranslation();
  const {
    showSurveyResult,
    showSurveyResultSkipped,
    openShowSurveyResultDialog,
    loadingShowSurveysResults,
  } = useSurveys();

  const closedState = useMemo(() => {
    return (
      showSurveyResultSkipped === true || loadingShowSurveysResults === true
    );
  }, [showSurveyResultSkipped, loadingShowSurveysResults]);

  const handleOpen = useCallback(() => {
    openShowSurveyResultDialog();
  }, [openShowSurveyResultDialog]);

  if (
    !closedState ||
    showSurveyResult === false ||
    SHOW_SURVEY_RESULTS === false
  ) {
    return null;
  }

  return (
    <Tooltip title={t("SURVEYS_RESULT_BTN_TOOLTIP")}>
      <IconButton onClick={handleOpen}>
        <Icon
          className={`fas fa-poll`}
          style={{
            width: "auto",
            height: "auto",
            padding: 1,
            color: "#8e44ad",
            fontSize: 22,
          }}
        />
      </IconButton>
    </Tooltip>
  );
}
